module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lista-solicitud-vacaciones contenedor-interno"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("Mis permisos generados")]), _c('span', {
    staticClass: "icon close",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })])]), _c('div', {
    staticClass: "is-desktop"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('table', {
    staticClass: "table is-striped is-bordered"
  }, [_vm._m(0), _c("transition-group", {
    tag: "tbody",
    attrs: {
      "name": "table-row"
    }
  }, _vm._l((_vm.lista), function(o, index) {
    return _c('tr', {
      key: index,
      staticClass: "row-table"
    }, [_c('td', [_c('span', {
      staticClass: "hint--top",
      attrs: {
        "aria-label": 'Solicitud: ' + o.idSolicitud
      }
    }, [_vm._v(_vm._s(o.descripcionTipo))])]), _c('td', [_vm._v(_vm._s(o.motivo))]), _c('td', [_c('div', {
      staticClass: "detalle"
    }, [_c('div', {
      staticClass: "flex"
    }, [_vm._v(_vm._s(o.desde === o.hasta ? o.desde : ((o.desde) + " - " + (o.hasta))) + " ")]), _c('strong', {
      staticClass: "flex"
    }, [_vm._v(_vm._s(o.horaDesde) + " - " + _vm._s(o.horaHasta))])])]), _c('td', {
      staticClass: "text-center"
    }, [(o.adjunto) ? [_c('a', {
      staticClass: "button is-small",
      attrs: {
        "href": o.adjunto,
        "target": "_blank"
      }
    }, [_vm._m(1, true), _c('span', [_vm._v("Ver adjunto")])])] : [_c('span', [_vm._v("Sin adjunto")])]], 2)])
  }), 0)], 1), (_vm.isLoading) ? _c('loading') : _vm._e()], 1)]), _c('div', {
    staticClass: "is-mobile"
  }, [(_vm.isLoading) ? _c('loading') : _vm._e(), _vm._l((_vm.lista), function(o, index) {
    return _c('div', {
      key: index,
      staticClass: "box"
    }, [_c('div', {
      staticClass: "descripcion-tipo hint--top",
      attrs: {
        "aria-label": 'Solicitud: ' + o.idSolicitud
      }
    }, [_c('span', [_vm._v(_vm._s(o.descripcionTipo))])]), _c('div', {
      staticClass: "motivo"
    }, [_c('div', [_c('span', [_vm._v(_vm._s(o.motivo))])])]), _c('div', {
      staticClass: "dias-pedidos"
    }, [_c('strong', [_vm._v("Dias pedidos")]), _c('div', [_c('span', {
      staticClass: "detalle-dias"
    }, [_vm._v(_vm._s(o.desde === o.hasta ? o.desde : ((o.desde) + " - " + (o.hasta))) + "   " + _vm._s(o.horaDesde) + "-" + _vm._s(o.horaHasta))])])]), _c('div', {
      staticClass: "botones"
    }, [(o.adjunto) ? [_c('a', {
      staticClass: "button is-small",
      attrs: {
        "href": o.adjunto,
        "target": "_blank"
      }
    }, [_vm._m(2, true), _c('span', [_vm._v("Ver adjunto")])])] : _vm._e()], 2)])
  })], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("Tipo")]), _c('th', [_vm._v("Motivo")]), _c('th', [_vm._v("Fecha")]), _c('th', [_vm._v("Adjunto")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-paperclip is-small fs-12"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-paperclip is-small fs-12"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-235f73ac","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Component_Permisos_Lista_Mis_Permisos.vue
// module id = 767
// module chunks = 0